<template>
  <div :class="[
    'image-selector-mini',
    'image-selector-mini--' + content
  ]">

    <!-- predefined images -->
    <div class="image-list clearfix d-flex">
      <div
        v-for="img in predefinedImageList"
        :key="img.id">
        <img
          :src="img.src_preview"
          :alt="img.name"
          :style="{
            border: img.src === value ? '2px solid #409EFF' : '2px solid #DCDFE6',
          }"
          @click="selectLibraryImage(img)" />
      </div>
      <div style="align-self: center;" v-if="allowUserUpload || allowPexelsSearch">
        <el-button
          size="normal"
          type="info"
          @click="show_more_options = !show_more_options">...</el-button>
      </div>
    </div>

    <!--
    Alternative: Dialog
    <el-dialog
      top="20vh"
      custom-class="image-upload-modal"
      title="FOO"
      :visible.sync="show_more_options"
      :is-nested="true"
      append-to-body
      @close=";">
      <ImageUpload :value="value" @input="inputImage" />
    </el-dialog>
    -->

    <div v-if="show_more_options" class="mt-4">
      <ImageUpload :value="value" @input="inputImage" :bucket="bucket" />
    </div>

  </div>
</template>

<script>
import ImageUpload from '@/components/Elements/ImageUpload'

const PREDEFINED_LIST_GOALS = [
  { id: 3,  src: 'https://images.pexels.com/photos/40751/running-runner-long-distance-fitness-40751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '40751' },
  { id: 4,  src: 'https://images.pexels.com/photos/533360/pexels-photo-533360.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '533360' },
  { id: 2,  src: 'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '106399' },
  { id: 1,  src: 'https://images.pexels.com/photos/1321730/pexels-photo-1321730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '1321730' },
  { id: 9,  src: 'https://images.pexels.com/photos/267582/pexels-photo-267582.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '267582' },
  { id: 5,  src: 'https://images.pexels.com/photos/1661004/pexels-photo-1661004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '1661004' },
  { id: 6,  src: 'https://images.pexels.com/photos/164474/pexels-photo-164474.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '164474' },
  { id: 7,  src: 'https://images.pexels.com/photos/346885/pexels-photo-346885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '346885' },
  { id: 8,  src: 'https://images.pexels.com/photos/442574/pexels-photo-442574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '442574' },
  { id: 10, src: 'https://images.pexels.com/photos/28080/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260', name: '28080' },
];

const PREDEFINED_LIST_DAYPLANNER = [
  { id: 1, src: 'https://images.unsplash.com/photo-1507608869274-d3177c8bb4c7?ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80', name: "photo-1507608869274-d3177c8bb4c7" },
  { id: 2, src: 'https://images.unsplash.com/photo-1510797215324-95aa89f43c33?ixlib=rb-1.2.1&auto=format&fit=crop&w=1875&q=80', name: "photo-1507608869274-d3177c8bb4c7" },
  { id: 3, src: 'https://images.unsplash.com/photo-1509149037-37dc57ccbd13?ixlib=rb-1.2.1&auto=format&fit=crop&w=1875&q=80', name: "photo-1509149037-37dc57ccbd13" },
  // { id: 4, src: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&auto=format&fit=crop&w=2700&q=80', name: "photo-1519681393784-d120267933ba" },
  { id: 5, src: 'https://images.unsplash.com/photo-1515825838458-f2a94b20105a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1534&q=80', name: "photo-1515825838458-f2a94b20105a" },
  { id: 6, src: 'https://images.unsplash.com/photo-1439853949127-fa647821eba0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1534&q=80', name: "photo-1439853949127-fa647821eba0" },
  { id: 9, src: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-1.2.1&auto=format&fit=crop&w=3900&q=80', name: "photo-1464822759023-fed622ff2c3b" },
  // { id: 7, src: 'https://images.unsplash.com/photo-1532278951723-545f655c97f9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1900&q=80', name: "photo-1532278951723-545f655c97f9" },
  // { id: 8, src: null, src_preview: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPcsmXrfwAHXwMets+XyQAAAABJRU5ErkJggg==' },
  { id: 8, src: null, src_preview: require( '@/assets/backgrounds/leaves-pattern.png' ) }
]

export default {
  props: {
    content: {},
    bucket: {},
    suggestionText: {},
    value: {},
    allowUserUpload: { default: true },
    allowPexelsSearch: { default: true },
  },
  data: () => ({
    show_more_options: false,
    image_option: 'upload',
    predefinedImageList: [],
  }),
  watch: {
    image_option(value) {
      if ( value === 'library' ) {
        this.onLoad();
      }
    }
  },
  mounted() {

    // Dayplanner:
    if ( this.content === 'dayplanner' ) {
      this.predefinedImageList = PREDEFINED_LIST_DAYPLANNER;
      this.predefinedImageList.forEach(item => {
        item.src_preview = item.src ? item.src.replace(/w=([0-9]+)/, 'h=128') : item.src_preview
      })
    }

    // Goals / Commitments:
    if ( this.content === 'commitment' || this.content === 'goal' ) {
      this.predefinedImageList = PREDEFINED_LIST_GOALS;

      this.predefinedImageList.forEach(item => {
        item.src_preview = item.src.replace('h=750&w=1260', 'h=64')
      })
    }

    /*,
    oldRealTimeDb
      .ref('predefined_goals')
      .limitToFirst(100)1
      .once("value", (snapshot) => {
        let val = snapshot.val();
        if ( !val ) {
          return
        }

        this.predefinedImageList = [];
        Object.keys(val).map(key => {
          this.predefinedImageList.push({ id: key, ...val[key] });
        });
      });
    */
  },
  computed: {
  },
  methods: {
    inputImage(image_url) {
      this.$emit('input', image_url)
    },

    selectLibraryImage(image) {
      // this.updateGoalFormImage();
      this.$emit('input', image.src)
    },

    /*
    updateGoalFormImage( url ) {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        this.imageRaw = image;
        this.imageDisplayURL = url;
      };
    },
    */
  },
  components: {
    ImageUpload
  }
}
</script>

<style>
.image-upload-modal {
  /*min-width: 700px; move to context*/
}
.image-selector-mini .image-list {
  flex-wrap: wrap;
  display: flex;
}
.image-selector-mini .image-list img {
  cursor: pointer;
  height: 64px;
  margin: 3px;
  padding: 1px;
}
.image-selector-mini--dayplanner .image-list img {
  height: 128px;
}
</style>
